import { Row } from '@tanstack/react-table';
import { CustomDataFieldType } from 'models/CustomDataField';
import {
  DisplayPreArrivalFormField,
  PreArrivalFormFields,
} from 'pages/automations/preArrivalForm/PreArrivalFormTab.types';
import { useTranslation } from 'react-i18next';

const DisplayTypeCell = ({ row }: { row: Row<DisplayPreArrivalFormField> }) => {
  const { id, type } = row.original;

  const { t } = useTranslation();

  const isCustomField = id === PreArrivalFormFields.CUSTOM;

  if (isCustomField) {
    const customFieldsText = {
      [CustomDataFieldType.TEXT]: t('pageAutomations.preArrivalForm.input'),
      [CustomDataFieldType.SINGLE_SELECT]: t(
        'pageAutomations.preArrivalForm.boolean',
      ),
      [CustomDataFieldType.LONG_TEXT]: t(
        'pageAutomations.preArrivalForm.input',
      ),
    };

    return <div>{customFieldsText[type] ?? type}</div>;
  }

  return (
    <div>
      {t(
        `pageAutomations.preArrivalForm.informationTable.fields.${id}.displayType`,
      )}
    </div>
  );
};

export default DisplayTypeCell;
